import { React, useEffect, useState } from 'react';
import FirstLevelMenuItem from './firstlevel';

const AnchorNavMultiLevelMobile = (props) => {
  if (typeof window === 'undefined') {
    return null;
  }
  const [current, setCurrent] = useState('');

  useEffect(() => {
    setCurrent(props.CurrentActive);
  }, []);

  return (
    <nav className="anchor-nav-multi__navigation">
      {props.AnchorNavigation && (
        <ul className="anchor-nav-multi__navigation__list">
          {props.AnchorNavigation?.map((item) => (
            <FirstLevelMenuItem
              key={item.Name}
              item={item}
              current={current}
              CloseNav={props.CloseNav}
            />
          ))}
        </ul>
      )}
    </nav>
  );
};

export default AnchorNavMultiLevelMobile;
